import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[secondaryButton]',
    standalone: false,
})
export class SecondaryButtonDirective {
    @HostBinding('class') elementClass = 'secondary-button';
}
